var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "div",
        { staticClass: "button-click-left", staticStyle: { float: "left" } },
        [
          _c(
            "el-select",
            {
              staticClass: "button-left-class",
              attrs: { placeholder: "Chọn đại lý" },
              on: {
                change: function ($event) {
                  return _vm.changeAgentMethod()
                },
              },
              model: {
                value: _vm.dataSearch.idAgent,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "idAgent", $$v)
                },
                expression: "dataSearch.idAgent",
              },
            },
            _vm._l(_vm.agentList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { value: item.id, label: item.agentName },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "button-left-class",
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "Chọn trường",
              },
              on: {
                change: function ($event) {
                  return _vm.searchHeaderMethod()
                },
              },
              model: {
                value: _vm.dataSearch.idSchool,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "idSchool", $$v)
                },
                expression: "dataSearch.idSchool",
              },
            },
            _vm._l(_vm.schoolList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: {
                  value: item.id,
                  label: item.id + " - " + item.schoolName,
                },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "button-left-class",
              attrs: { placeholder: "Chọn trạng thái" },
              on: {
                change: function ($event) {
                  return _vm.searchHeaderMethod()
                },
              },
              model: {
                value: _vm.dataSearch.deleteStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "deleteStatus", $$v)
                },
                expression: "dataSearch.deleteStatus",
              },
            },
            _vm._l(_vm.deleteList, function (item) {
              return _c("el-option", {
                key: item.key,
                attrs: { value: item.key, label: item.value },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Chọn đối tượng", clearable: "" },
              on: {
                change: function ($event) {
                  return _vm.searchHeaderMethod()
                },
              },
              model: {
                value: _vm.dataSearch.accountType,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "accountType", $$v)
                },
                expression: "dataSearch.accountType",
              },
            },
            _vm._l(_vm.appTypeList, function (item) {
              return _c("el-option", {
                key: item.key,
                attrs: { label: item.value, value: item.key },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "button-click row-data" },
        [
          _c(
            "el-button",
            {
              staticClass: "button-over",
              attrs: { type: "success" },
              on: { click: _vm.createFeedBackHiddenDialog },
            },
            [
              _c("i", { staticClass: "el-icon-plus" }),
              _vm._v("\n      Tạo góp ý\n    "),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "button-over",
              attrs: { type: "success" },
              on: { click: _vm.deleteMultiFeedBackById },
            },
            [
              _c("i", { staticClass: "el-icon-delete" }),
              _vm._v("\n      Xóa tất cả\n    "),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "table-content row-data",
          staticStyle: { "margin-top": "20px" },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingData,
                  expression: "loadingData",
                },
              ],
              attrs: {
                data: _vm.dataResponseList,
                "empty-text": _vm.textTable,
                "element-loading-text": _vm.$tableLoading,
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255, 0)",
                "default-sort": { prop: "createdDate", order: "descending" },
                "sort-chang": { prop: "createdBy", order: "descending" },
                "highlight-current-row": "",
                "cell-style": _vm.tableRowStyleDetail,
                "header-cell-style": _vm.tableHeaderColor,
                "max-height": _vm.$tableMaxHeight,
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  type: "index",
                  label: "STT",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  width: "140px",
                  prop: "createdDate",
                  label: "Thời gian",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDateTime")(scope.row.createdDate)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  width: "170px",
                  prop: "createdBy",
                  label: "Người góp ý",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "hiddenStatus",
                  label: "Ẩn danh",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.hiddenStatus
                          ? _c("span", [_vm._v("Có")])
                          : _c("span", [_vm._v("Không")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200px",
                  prop: "feedbackTitle",
                  label: "Tiêu đề",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "300px",
                  prop: "feedbackContent",
                  label: "Nội dung",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "80px",
                  prop: "fileNumber",
                  label: "Số File",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150px",
                  prop: "replyName",
                  label: "Người trả lời",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Tình trạng", width: "100px", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.schoolUnread
                          ? _c("span", [_vm._v("Đã đọc")])
                          : _c("span", [_vm._v("Chưa đọc")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120px",
                  prop: "schoolConfirmStatus",
                  label: "Trạng thái xác nhận",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.schoolConfirmStatus
                          ? _c("span", [_vm._v("Đã xác nhận")])
                          : _c("span", [_vm._v("Chưa xác nhận")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "schoolUnread",
                  label: "Trạng thái xem",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.schoolUnread == true
                          ? _c("span", { staticStyle: { color: "#303133" } }, [
                              _vm._v("Đã xem"),
                            ])
                          : _c(
                              "span",
                              {
                                staticStyle: { color: "#f56c6c" },
                                attrs: { type: "text" },
                              },
                              [_vm._v("Chưa xem")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: "Tác vụ",
                  width: "160px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.viewFeedback(scope.row)
                              },
                            },
                          },
                          [_vm._v("Xem")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteFeedBackById(scope.row)
                              },
                            },
                          },
                          [_vm._v("Xóa")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "paging-click row-data" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.pageNumber,
              "page-sizes": _vm.$pageListDefaultNew,
              "page-size": _vm.maxPageItem,
              layout: _vm.$pageLayoutDefault,
              total: _vm.pageTotal,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("FeedBackOnekidsDetail", {
        ref: "FeedBackOnekidsDetail",
        attrs: { dialogVisible: _vm.showCreateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseCreateMethod()
          },
        },
      }),
      _c("CreateaFeedBackHidden", {
        ref: "CreateaFeedBackHidden",
        attrs: { dialogVisible: _vm.showCreateFeedBackHiddenDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseFeedBackHidden()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }